import { useSearchParams } from 'react-router-dom';
import { TIMELINE_QUERY_PARAM, viewedTimelineId } from '../notifications/viewed-timeline';

// The timeline the dashboard is showing: ?timeline= from the URL, else the engagement's main.
export const useViewedTimelineId = (mainTimelineId: number | undefined): number | undefined => {
    const [searchParams] = useSearchParams();
    return viewedTimelineId(searchParams.get(TIMELINE_QUERY_PARAM), mainTimelineId);
};
